(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myntelo-atmosphere"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'myntelo:last-aura-product';
    let lastDestination = '';
    try { lastDestination = sessionStorage.getItem(storageKey) || ''; } catch (_) {}
    const randomIndex = length => {
      if (window.crypto?.getRandomValues) {
        const range = 4294967296;
        const limit = range - range % length;
        const value = new Uint32Array(1);
        do { window.crypto.getRandomValues(value); } while (value[0] >= limit);
        return value[0] % length;
      }
      return Math.floor(Math.random() * length);
    };
    const choose = urls => {
      const candidates = urls.length > 1 ? urls.filter(url => url !== lastDestination) : urls;
      return candidates[randomIndex(candidates.length)];
    };
    const remember = url => {
      lastDestination = url;
      try { sessionStorage.setItem(storageKey, url); } catch (_) {}
    };
    const mount = scope => {
      const sections = [...scope.querySelectorAll('[data-aura-portals]')];
      if (scope.matches?.('[data-aura-portals]')) sections.unshift(scope);
      sections.forEach(section => {
        if (section.dataset.portalsMounted) return;
        let raw;
        try { raw = JSON.parse(section.querySelector('[data-aura-products]')?.textContent || '[]'); } catch (_) { return; }
        if (!Array.isArray(raw)) return;
        const urls = [...new Set(raw.filter(value => {
          if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return false;
          try { const url = new URL(value, location.origin); return url.origin === location.origin && /\/products\/[^/]+\/?$/.test(url.pathname); } catch (_) { return false; }
        }))];
        if (!urls.length) return;
        section.dataset.portalsMounted = 'true';
        const links = [...section.querySelectorAll('[data-aura-portal]')];
        const refresh = () => links.forEach(link => { link.setAttribute('href', choose(urls)); });
        const activate = event => {
          const link = event.target.closest('[data-aura-portal]');
          if (!link || !section.contains(link) || event.defaultPrevented) return;
          if (event.type === 'auxclick' && event.button !== 1) return;
          const destination = choose(urls);
          link.setAttribute('href', destination);
          remember(destination);
        };
        section.addEventListener('click', activate);
        section.addEventListener('auxclick', activate);
        window.addEventListener('pageshow', refresh);
        refresh();
      });
    };
    mount(document);
    document.addEventListener('shopify:section:load', event => mount(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myntelo-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const heroes = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  const motionAllowed = () => !reduced.matches && !navigator.connection?.saveData && document.documentElement.dataset.motion !== 'paused' && !document.hidden;
  let frame = 0;
  function updateScroll() {
    frame = 0;
    heroes.forEach((state, hero) => {
      if (!motionAllowed()) {
        state.studio.style.removeProperty('--orbital-rise');
        return;
      }
      const box = hero.getBoundingClientRect();
      if (box.bottom < 0 || box.top > innerHeight) return;
      const progress = Math.min(1, Math.max(0, -box.top / box.height));
      state.studio.style.setProperty('--orbital-rise', `${(-progress * 14).toFixed(2)}px`);
    });
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(updateScroll); }
  function mount(scope = document) {
    scope.querySelectorAll('[data-orbital-hero]').forEach(hero => {
      if (heroes.has(hero)) return;
      const studio = hero.querySelector('[data-orbital-studio]');
      const controls = hero.querySelector('[data-orbital-controls]');
      const reset = () => {
        studio.style.removeProperty('--orbital-turn');
        studio.style.removeProperty('--orbital-tilt');
      };
      const move = event => {
        if (!motionAllowed() || !fine.matches) return;
        const box = studio.getBoundingClientRect();
        const x = Math.max(-1, Math.min(1, (event.clientX - box.left) / box.width * 2 - 1));
        const y = Math.max(-1, Math.min(1, (event.clientY - box.top) / box.height * 2 - 1));
        studio.style.setProperty('--orbital-turn', `${(x * 6).toFixed(2)}deg`);
        studio.style.setProperty('--orbital-tilt', `${(-y * 4).toFixed(2)}deg`);
      };
      const select = event => {
        const button = event.target.closest('[data-orbital-select]');
        if (!button || !hero.contains(button)) return;
        const selected = button.dataset.orbitalSelect;
        hero.querySelectorAll('[data-orbital-view]').forEach(view => {view.hidden = view.dataset.orbitalView !== selected;});
        hero.querySelectorAll('[data-orbital-select]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        reset();
      };
      studio.addEventListener('pointermove', move);
      studio.addEventListener('pointerleave', reset);
      hero.addEventListener('click', select);
      if (controls) controls.hidden = false;
      heroes.set(hero, {studio, reset, move, select});
    });
    schedule();
  }
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    heroes.forEach((state, hero) => {
      if (!event.target.contains(hero)) return;
      state.studio.removeEventListener('pointermove', state.move);
      state.studio.removeEventListener('pointerleave', state.reset);
      hero.removeEventListener('click', state.select);
      heroes.delete(hero);
    });
  });
  new MutationObserver(() => {
    if (!motionAllowed()) heroes.forEach(state => state.reset());
    schedule();
  }).observe(document.documentElement, {attributes:true, attributeFilter:['data-motion']});
  reduced.addEventListener('change', () => {heroes.forEach(state => state.reset());schedule();});
  document.addEventListener('visibilitychange', schedule);
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  mount();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myntelo-home-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
